import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { dateFormat } from '../../../../api/dateFormat';
import { Link } from 'react-router-dom';
import { usePagination } from '@material-ui/lab/Pagination';
import PropTypes from 'prop-types';

export default function DataTables(props) {
  const populateSubjectCol = () => {
    const list = [];
    Object.keys(props.filteredKeys).map((key) => {
      list.push({ id: key, label: key, align: 'right' });
    });
    return list;
  };
  const extractFromArray = () => {
    const columns = [
      { id: 'Exam', label: 'Exam' },
      { id: 'Date', label: 'Date' },
      { id: 'Rank', label: 'Rank', align: 'right' },
      { id: 'BatchRank', label: 'CR', align: 'right' },
      { id: 'Status', label: 'Status', align: 'center' },
      { id: 'Total', label: 'Total', align: 'right' },
      { id: 'per', label: '%', align: 'right' },
      { id: 'action', label: 'Action', align: 'center' },
    ];
    const list = populateSubjectCol().reverse();
    for (let i = 0; i < list.length; i++) {
      columns.splice(5, 0, list[i]);
    }
    return columns;
  };
  const columnFail = [
    { id: 'Exam', label: 'Exam' },
    { id: 'Date', label: 'Date' },
    { id: 'action', label: 'Action' },
  ];

  let columns = props.present ? extractFromArray() : columnFail;

  const rowData = () => {
    const rows = [];
    props.testData.map((data) => {
      rows.push({
        Exam: data.TestName,
        Date: dateFormat(data.TestDate),
        Rank: data.Rank,
        BatchRank: data.BatchRank,
        Status: data.Status,
        Chem: data.Chem,
        Math: data.Math,
        Bio: data.Bio,
        Bot: data.Bot,
        Zoo: data.Zoo,
        MAT: data.MAT,
        sst: data.sst,
        English: data.English,
        Phy: data.Phy,
        Total: data.Total,
        per: data.Per,
        action: 'Analysis',
        TestID: data.TestID,
      });
    });
    return rows;
  };
  const failRow = () => {
    const rows = [];
    props.testData.map((data) => {
      rows.push({
        Exam: data.TestName,
        Date: dateFormat(data.TestDate),
        action: 'Solution',
        TestID: data.TestID,
      });
    });
    return rows;
  };

  const rows = props.present ? rowData() : failRow();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const defaultLabelDisplayedRows = () => {
    let count = rows.length;
    const from = count === 0 ? 0 : page * rowsPerPage + 1;
    const to =
      count !== -1
        ? Math.min(count, (page + 1) * rowsPerPage)
        : (page + 1) * rowsPerPage;
    return `Showing ${from} to ${to} of ${count !== -1 ? count : `more than ${to}`
      } entries `;
  };
  const totalPages =
    rows.length === 0 || rowsPerPage === 0
      ? 0
      : Math.ceil(rows.length / rowsPerPage);

  const ActionsComponent = () => {
    return CustomPagination(totalPages);
  };
  const handleButtonDisable = (type) => {
    let disable = false;
    if (rows.length <= 10) {
      disable = true;
    } else if (type === 'previous' && page === 0) {
      disable = true;
    } else if (type === 'next' && page === totalPages - 1) {
      disable = true;
    }
    return disable;
  };

  const setPageValue = (pag, type) => {
    const totalPages =
      rows.length === 0 || rowsPerPage === 0
        ? 0
        : Math.ceil(rows.length / rowsPerPage);
    const currentPage = page;
    if (type === 'next') {
      currentPage !== totalPages - 1
        ? setPage(currentPage + 1)
        : setPage(currentPage);
    } else if (type === 'previous') {
      currentPage !== 0 ? setPage(currentPage - 1) : setPage(currentPage);
    } else {
      setPage(pag - 1);
    }
  };

  const CustomPagination = (totalPages) => {
    const pageNo = page;
    const { items } = usePagination({
      count: totalPages,
    });

    return (
      <nav>
        <ul className="table-pagination">
          {items.map(({ page, type, ...item }, index) => {
            let children = null;
            if (type === 'start-ellipsis' || type === 'end-ellipsis') {
              children = '…';
            } else if (type === 'page') {
              children = (
                <button
                  className={
                    pageNo + 1 === index
                      ? 'pagination-active-buttons'
                      : 'pagination-inactive-buttons'
                  }
                  key={`button ${page}`}
                  type="button"
                  {...item}
                >
                  {page}
                </button>
              );
            } else {
              children = (
                <button
                  className="pagination-main-buttons"
                  type="button"
                  key={`buttons ${page}`}
                  disabled={handleButtonDisable(type)}
                >
                  {type === 'previous' ? 'Previous' : 'Next'}
                </button>
              );
            }
            return (
              <li key={index} onClick={() => setPageValue(page, type, index)}>
                {children}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };

  return (
    <React.Fragment>
      <TableContainer className="table-container nowrap">
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      let value = row[column.id];
                      if (value === 'P') {
                        value = <span className="label success">PRESENT</span>;
                      }
                      if (value === 'A') {
                        value = <span className="label fail">ABSENT</span>;
                      }
                      if (value === 'Analysis') {
                        value = (
                          <Link
                            to={'/test-performance-analysis/' + row.TestID}
                            className="link"
                          >
                            Analysis
                          </Link>
                        );
                      }
                      if (value === 'Solution') {
                        value = (
                          <div
                            className="link"
                            onClick={() => {
                              props.handleSolution(row.TestID);
                              console.log('row.ID ', row.TestID);
                            }}
                          >
                            Solution
                          </div>
                        );
                      }
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className="custom-pagination"
        rowsPerPageOptions={[]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        labelDisplayedRows={defaultLabelDisplayedRows}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={ActionsComponent}
      />
    </React.Fragment>
  );
}
DataTables.propTypes = {
  testData: PropTypes.object,
  present: PropTypes.bool,
  filteredKeys: PropTypes.object,
  handleSolution: PropTypes.func,
};
